import { SelectionModel } from '@angular/cdk/collections';
import { Tag } from './tag';

export class TagSelection extends SelectionModel<Tag> {
    updateFilter(tag: Tag) {
        if (tag.filter) {
            this.selected.find((t) => t.tag === tag.tag).filter = tag.filter;
        }
    }
}
